import React, { FC, ReactNode } from 'react'
import AttendeeNavbar from '../../navbar/AttendeeNavbar'
import AttendeeFooter from '../../footer/AttendeeFooter'



interface Props{
  children: ReactNode
}

const AttendeeLayout: FC<Props> = ({children}) => {
  return (
    <div>
       <AttendeeNavbar/>
        <div className="page-container">
          {children}
        </div>
        <AttendeeFooter/>
    </div>
  )
}

export default AttendeeLayout
